export class IntroBanner {
  backgroundImageUrl: string;
  foregroundImageUrl: string;
}
